import * as React from 'react';
import LiquidacionDetalleTabla from './LiquidacionDetalleTabla';
import DetalleVerBoton from './DetalleVerBoton';

const TABLE_HEAD = (
    <tr>
        <th scope="col">N° Orden</th>
        <th scope="col">Tipo</th>
        <th scope="col">Estado</th>
        <th scope="col">Fecha</th>
        <th scope="col">Importe</th>
        <th scope="col">Comisión Neta</th>
        <th scope="col">Comisión Total</th>
        <th scope="col">Importe Total</th>
        <th scope="col">Total Retenciones</th>
    </tr>
);

export default class OrdenesDeLiquidacionBorrador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ordenes: props.ordenes ?? [],
            seleccionarTodo: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.ordenes !== this.props.ordenes) {
            this.setState({
                ordenes: this.props.ordenes ?? [],
            });
        }
    }

    handleChangeCheckbox = (id) => {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => {
                if (orden.idOrden === id) {
                    return {
                        ...orden,
                        checked: !orden.checked,
                    };
                }
                return orden;
            });
            return { ordenes };
        });
    };

    handleSelectAllCheckbox(seleccionarTodo) {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => ({
                ...orden,
                checked: seleccionarTodo,
            }));
            return { ordenes, seleccionarTodo };
        });
    }

    render = () => (
        <LiquidacionDetalleTabla
            title="Órdenes"
            data={this.state.ordenes}
            isLoading={this.props.isLoading}
            loadingMessage="Cargando ordenes del borrador..."
            emptyMessage="No hay órdenes para esta liquidación"
            tableHead={TABLE_HEAD}
            renderRow={(orden, i, globalIndex) => (
                <tr key={orden.idOrden ?? globalIndex} className="hover-background-color">
                    <td><small>{orden.idOrden}</small></td>
                    <td><small>{orden.tipoPublicacionMostrar}</small></td>
                    <td><small>{orden.estado}</small></td>
                    <td><small>{orden.fechaMostrar}</small></td>
                    <td><small>${orden.totalOrden}</small></td>
                    <td><small>${orden.comisionNeto}</small></td>
                    <td><small>${orden.totalComision}</small></td>
                    <td><small>${orden.importe}</small></td>
                    <td>
                        <span className="d-inline-flex align-items-center flex-wrap gap-1">
                            <small>${orden.retencion}</small>
                            {orden.retencion > 0 && this.props.onVerDetalleRetenciones && (
                                <DetalleVerBoton
                                    title="Ver detalle de retenciones"
                                    onClick={() => this.props.onVerDetalleRetenciones(orden.idOrden, 'orden')}
                                />
                            )}
                        </span>
                    </td>
                </tr>
            )}
        />
    );
}
